/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
  MessageHeader, Message,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
// import Results from "./Results.js";

import MyCarousel from "./Carousel.js";
// import Video from './Video.js';
import YouTube from './YouTube.js';
// import overview from "./images/framework-crop-1.jpg";
// import teaser from './images/teaser.png';
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";
// import MyCarousel from "./Carousel.js";
// import fig_noisy from './images/fig_noisy.jpg'
import './App.css'
// import './Carousel.css'
import overview from './images/overview.jpg'
import method from './images/method.jpg'
// import video_results from './images/results5.mp4'
// import video_results7 from './images/results7.mp4'

import LazyVideo from "./lazy-video";
import motion from './images/motion_magnitude.mp4'
import dataset from './images/dataset_web.mp4'

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      Diffusion4D: Fast Spatial-temporal Consistent
4D Generation via Video Diffusion Models
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const Authors = () => (      <Container text>
  {/* <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
  </Grid> */}
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}
    <a href="#" target="_blank" rel="noreferrer">
      Hanwen Liang<sup>1*</sup>
    </a>
    <a href="https://yuyangyin.github.io/" target="_blank" rel="noreferrer">
      Yuyang Yin<sup>2*</sup>
    </a>
    <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
      Dejia Xu<sup>3</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
      Hanxue Liang<sup>4</sup>
    </a>
    <a
      href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
      target="_blank"
      rel="noreferrer"
    >
      Zhangyang Wang<sup>3</sup>
    </a>
    <a href="https://www.comm.utoronto.ca/~kostas/" target="_blank" rel="noreferrer">
      Konstantinos N. Plataniotis<sup>1</sup>
    </a>
    <a href="https://faculty.bjtu.edu.cn/5900/" target="_blank" rel="noreferrer">
      Yao Zhao<sup>2</sup>
    </a>
    <a href="https://weiyc.github.io/" target="_blank" rel="noreferrer">
      Yunchao Wei<sup>2</sup>
    </a>
    {/* </Grid.Column> */}
    {/* </Grid.Row> */}
  </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    <div>
      <sup>1</sup>University of Toronto, <sup>2</sup>Beijing Jiaotong University, <br></br> <sup>3</sup>University of Texas at Austin, <sup>4</sup>University of Cambridge<br />
      <sup>*</sup>Equal contribution
    </div>
  {/* </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  > */}
    {/* <br /> */}
    {/* <div>*denotes equal contribution</div> */}
  </Grid>
  <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon >
              <a
                href="https://arxiv.org/abs/2405.16645"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon >
              <a
                href="https://github.com/VITA-Group/Diffusion4D"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
            <Button primary icon >
              <a
                href="https://huggingface.co/datasets/hw-liang/Diffusion4D"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github alternate" />
                {" Dataset"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
</Container>
)

const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // height: '100vh', // Full viewport height
  // backgroundColor: '#f0f0f0', // Optional: background color
};

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Authors />

      <Container text style={{textAlign: "justify",}}>
      {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Overview
        </Header> */}
        <p>
        {/* <b>TL;DR:</b> We present a novel 4D content generation framework, <b>Diffusion4D</b>, that, for the first time, adapts <b>video diffusion models</b> for explicit synthesis of spatial-temporal consistent novel views of 4D assets. The 4D-aware video diffusion model can seamlessly integrate with the off-the-shelf modern 4D construction pipelines to efficiently create 4D content within <b>several minutes</b>. */}
        <b>TL;DR:</b> We present a novel 4D content generation framework, <b>Diffusion4D</b>, that, for the first time, adapts video diffusion models for explicit synthesis of spatial-temporal consistent novel views of 4D assets. Leveraging a meticulously curated dynamic 3D dataset, we develop a <b>4D-aware video diffusion model</b> capable of synthesizing orbital views of dynamic 3D assets. The 4D-aware video diffusion model can seamlessly integrate with the off-the-shelf modern 4D construction pipelines to efficiently create 4D content within <b>several minutes</b>. Our method surpasses prior arts in terms of generation efficiency and 4D geometry consistency across various prompt modalities, i.e. text, single image and 3D asset.
        </p>
        <MyCarousel mobile={mobile} ></MyCarousel>
        <p>
        To control the dynamic strength of 4D assets, we introduce a <b>3D-to-4D motion magnitude</b> metric as guidance. The following examples demonstrate cases with varying motion magnitudes, arranged from small to large in each row.
        </p>
        <div style={containerStyle} centered="true">
        <LazyVideo nocontrol src={motion} width="60%"></LazyVideo>
        {/* <LazyVideo nocontrol src={motion} width="100%"></LazyVideo> */}
        </div>
        {/* <LazyVideo src={video_results} no_control></LazyVideo>
        <LazyVideo src={video_results7} no_control></LazyVideo> */}
        {/* <br></br> */}
        {/* <Comparison /> */}
        {/* <Results /> */}
        {/* <Abstract mobile={mobile} /> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Visualizations
        </Header> */}
        {/* <MyCarousel mobile={mobile} /> */}
        
        {/* </p> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        Overview
        </Header>
        <p>
        Decomposition of spatial-temporal consistency in 4D generation. The proposed Diffusion4D
embeds geometrical consistency and temporal coherence into a single network.
<Image src={overview} style={subsection_style} centered="true" ></Image>
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Dataset
        </Header>
        <p>
        We collect 365k dynamic 3D assets from Objaverse-1.0 (42k) and Objaverse-xl (323k). We curate a high-quality subset to train our models. The Objaverse-1.0 part (12k) of the curated subset can be found in <a href="https://github.com/VITA-Group/Diffusion4D/blob/main/rendering/src/ObjV1_curated.txt" target="_blank" rel="noreferrer">Github</a>. <br></br>
        Metadata of animated objects (323k) from Objaverse-xl can be found in <a href="https://huggingface.co/datasets/hw-liang/Diffusion4D" target="_blank" rel="noreferrer">HuggingFace</a>. We also release the metadata of all successfully rendered objects from Objaverse-xl's Github subset. 
        <br></br>
        The released rendered data from <a href="https://huggingface.co/datasets/hw-liang/Diffusion4D/tree/main/objaverse1.0_curated" target="_blank" rel="noreferrer">the curated Objaverse 1.0</a> includes orbital videos of dynamic 3D assets, orbital videos of static 3D assets, and monocular videos from the front view. 
        
        {/* Released rendered data from , including orbital videos of dynamic 3D, orbital videos of static 3D, and monocular videos from front view. */}
        {/* <i>(2024.6.4 update): Released rendered data from <a href="https://huggingface.co/datasets/hw-liang/Diffusion4D/tree/main/objaverse1.0_curated" target="_blank" rel="noreferrer">curated Objaverse 1.0</a>, including orbital videos of dynamic 3D, orbital videos of static 3D, and monocular videos from front view.</i> */}
        <br></br>
        <b>
          We are actively uploading the renderings of the data to facilitate future research.
          </b>
        </p>
        <div style={containerStyle} centered="true">
        <LazyVideo nocontrol src={dataset} width="70%"></LazyVideo>
        {/* <LazyVideo nocontrol src={motion} width="100%"></LazyVideo> */}
        </div>
        {/* <br></br> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        Method
        </Header>
        <p>
        Here's an overview of our proposed <b>Diffusion4D</b> method. Our proposed Diffusion4D consists of a 4D-aware video diffusion model and explicit 4D
construction, capable of synthesizing 4D assets conditioned on text, single images, or static 3D assets.
        </p>
        <Image src={method} style={subsection_style} centered="true" ></Image>
        
        <Header as="h2" textAlign="center" style={subsection_style}>
          Video (narrated)
        </Header>
        <br></br>
        <YouTube src={`https://www.youtube.com/embed/XJT-cMt_xVo?rel=0&amp;autoplay=p1&mute=1`}></YouTube>
        {/* <Video /> */}
        {/* <p> */}
        <Header as="h4" textAlign="center" style={{fontSize: '1em'}}>
            <a href="https://b23.tv/ojVe6Uv" target="_blank"
                rel="noreferrer"> 
          <i>Watch on bilibili (Chinese) 
                {/* here */}
              </i>
                </a>
                </Header>
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
        Results
        </Header>
        <p>
        We show our generated results of three tasks, text to 4D generation, single image to 4D generation and Static-3D to 4D generation.
For each prompt, we also show the outputs from VideoMV that are the orbital view videos of static 3D assets. For our methods, we use Diffusion4D star to denote generated videos from 4D-aware video diffusion model and Diffusion4D to denote rendered views from 4D construction.
        <br></br>
        </p>
        {/* <Image src={fig_noisy} style={subsection_style}></Image> */}
        {/* <YouTube src={`https://www.youtube.com/embed/sg7uUUfpM-c?rel=0&amp;autoplay=p1&mute=1`}></YouTube> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If you want to cite our work, please kindly use:
          <pre>
            <code>
              {`@article{liang2024diffusion4d,
  title={Diffusion4D: Fast Spatial-temporal Consistent
    4D Generation via Video Diffusion Models},
  author={Liang, Hanwen and Yin, Yuyang and Xu, Dejia and Liang, Hanxue and Wang, Zhangyang and Plataniotis, Konstantinos N and Zhao, Yao and Wei, Yunchao},
  journal={arXiv preprint arXiv:2405.16645},
  year={2024}
}`}
            </code>
          </pre>
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Relevant Works
        </Header>
        <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/Comp4D/" target="_blank" rel="noreferrer">
    Comp4D: LLM-Guided Compositional 4D Scene Generation
    </a></MessageHeader>
    Our Compositional 4D Generation (Comp4D) framework integrates GPT-4 to decompose the scene and design proper trajectories, resulting in larger-scale movements and more realistic object interactions.
  </Message>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/4DGen/" target="_blank" rel="noreferrer">
    4DGen: Grounded 4D Content Generation with Spatial-temporal Consistency
    </a></MessageHeader>
    We introduce grounded 4D content generation. We identify static 3D assets and monocular video sequences as key components in constructing the 4D content. 
  </Message>
        <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/3D-Mode-Collapse/" target="_blank" rel="noreferrer">
    Taming Mode Collapse in Score Distillation for Text-to-3D Generation
    </a></MessageHeader>
    We derive an entropy-maximizing score distillation rule that fosters view diversity and address the multi-face problem for text-to-3D generation.
  </Message>
        <br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
